import { render } from "./MaterialPresentSelect.vue?vue&type=template&id=20b3c02f"
import script from "./MaterialPresentSelect.vue?vue&type=script&lang=js"
export * from "./MaterialPresentSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__